@if (articles && articles.length) {
  <div class="container bgr-white layout-row align-center text-center">
    <div class="layout-column full-w spacer-top-48">
      <div class="layout-row align-left spacer-left-32 spacer-bottom-48">
        <h1>You searched for: {{terms}}</h1>
      </div>
    </div>
  </div>
  <div class="container layout-row flex-wrap">
    @for (item of articles; track item) {
      <div class="flex-half-tablet spacer-bottom-40">
        <div class="category-snippet">
          <gh-snippet-mobile [article]="item" class="snippet-wrapper"></gh-snippet-mobile>
        </div>
      </div>
    }
  </div>
}

@if (!articles || !articles.length) {
  <div class="container bgr-white layout-row align-center text-center">
    <div class="layout-column spacer-top-16">
      <div class="layout-row align-center">
        <svg width="112" height="123" viewBox="0 0 112 123" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M94.1801 48.2029C90.0447 48.2029 86.0787 46.5602 83.1545 43.636C80.2304 40.7119 78.5876 36.7459 78.5876 32.6105C78.7906 29.8445 79.5482 27.1477 80.8151 24.6806C73.0645 19.9073 64.1803 17.2891 55.0798 17.0962C45.9792 16.9033 36.9921 19.1428 29.0462 23.5834C21.1003 28.0241 14.4835 34.5049 9.87893 42.357C5.27437 50.2091 2.84889 59.1478 2.85288 68.2504C2.85764 70.4867 3.02141 72.7198 3.34293 74.9328H104.827C105.149 72.7198 105.313 70.4867 105.318 68.2504C105.314 60.845 103.687 53.5304 100.551 46.8219C98.5457 47.7184 96.3763 48.1887 94.1801 48.2029Z"
            fill="#B2F5F5" />
          <path
            d="M54.0852 81.6157C51.7222 81.6157 49.4559 82.5545 47.7849 84.2254C46.114 85.8963 45.1753 88.1626 45.1753 90.5257V103.891H62.9952V90.5257C62.9952 88.1626 62.0565 85.8963 60.3855 84.2254C58.7146 82.5545 56.4483 81.6157 54.0852 81.6157ZM58.5402 99.4357H49.6302V90.5257C49.6302 89.3442 50.0996 88.211 50.9351 87.3755C51.7706 86.5401 52.9037 86.0707 54.0852 86.0707C55.2668 86.0707 56.3999 86.5401 57.2354 87.3755C58.0709 88.211 58.5402 89.3442 58.5402 90.5257V99.4357Z"
            fill="#284154" />
          <path d="M42.2279 46.0784L15.5196 54.989L16.9295 59.215L43.6378 50.3044L42.2279 46.0784Z" fill="#284154" />
          <path d="M65.9526 46.1031L64.5442 50.3296L91.2556 59.2308L92.6641 55.0043L65.9526 46.1031Z" fill="#284154" />
          <path
            d="M112 32.6105C112 23.7005 97.6104 4.45498 95.9621 2.31659L94.1801 0L92.3981 2.31659C87.7575 8.37157 83.6156 14.7929 80.0132 21.5176C68.914 15.3118 55.9747 13.2404 43.4929 15.6712C31.0112 18.102 19.7948 24.8776 11.8355 34.7949C3.87627 44.7122 -0.310752 57.1294 0.0179845 69.8414C0.346721 82.5534 5.16994 94.7375 13.6312 104.23C22.0924 113.723 33.644 119.91 46.2347 121.692C58.8254 123.475 71.6404 120.737 82.404 113.966C93.1675 107.195 101.183 96.8282 105.027 84.7069C108.872 72.5857 108.296 59.4943 103.402 47.7574C106.011 46.1794 108.172 43.958 109.678 41.306C111.183 38.654 111.983 35.66 112 32.6105ZM94.1801 7.39527C99.0805 14.1223 107.545 26.9527 107.545 32.6105C107.545 36.1551 106.137 39.5545 103.631 42.0609C101.124 44.5674 97.7247 45.9754 94.1801 45.9754C90.6355 45.9754 87.236 44.5674 84.7296 42.0609C82.2232 39.5545 80.8151 36.1551 80.8151 32.6105C80.8151 26.9527 89.2796 14.1223 94.1801 7.39527ZM34.0378 72.7053C34.7787 72.7735 35.5243 72.7735 36.2653 72.7053V114.092C34.7506 113.468 33.2359 112.8 31.8103 112.043V72.7053C32.5512 72.7735 33.2968 72.7735 34.0378 72.7053ZM74.1326 72.7053C74.8736 72.7735 75.6192 72.7735 76.3601 72.7053V112.087C74.89 112.8 73.4198 113.468 71.9051 114.092V72.7053C72.6461 72.7735 73.3917 72.7735 74.1326 72.7053ZM103.09 68.2504C103.083 76.4025 101.042 84.4242 97.1527 91.5887C93.2632 98.7532 87.6478 104.834 80.8151 109.281V70.4333C82.1983 69.3959 83.321 68.0507 84.0943 66.5042C84.8675 64.9577 85.2701 63.2524 85.2701 61.5233H80.8151C80.8151 63.2956 80.1111 64.9954 78.8578 66.2486C77.6046 67.5018 75.9049 68.2058 74.1326 68.2058C72.3603 68.2058 70.6606 67.5018 69.4074 66.2486C68.1542 64.9954 67.4501 63.2956 67.4501 61.5233H62.9952C62.9882 63.2536 63.3877 64.9613 64.1615 66.5089C64.9353 68.0565 66.0617 69.4007 67.4501 70.4333V115.34C58.7232 117.894 49.4472 117.894 40.7202 115.34V70.4779C42.1086 69.4453 43.2351 68.1011 44.0089 66.5535C44.7827 65.0059 45.1822 63.2981 45.1752 61.5679H40.7202C40.7202 63.3402 40.0162 65.0399 38.763 66.2931C37.5098 67.5463 35.8101 68.2504 34.0378 68.2504C32.2655 68.2504 30.5657 67.5463 29.3125 66.2931C28.0593 65.0399 27.3553 63.3402 27.3553 61.5679H22.9003C22.8826 63.3 23.2774 65.0114 24.052 66.5608C24.8267 68.1101 25.959 69.4528 27.3553 70.4779V109.37C16.8197 102.375 9.39596 91.5788 6.63621 79.2376C3.87645 66.8965 5.99438 53.9662 12.5472 43.1504C19.0999 32.3345 29.5802 24.4706 41.7967 21.2028C54.0132 17.935 67.02 19.5163 78.0976 25.6162C77.094 27.8212 76.5051 30.1922 76.3601 32.6105C76.3248 35.402 76.9541 38.1619 78.1962 40.6622C79.4382 43.1624 81.2573 45.3313 83.5032 46.9896C85.7491 48.6479 88.3573 49.748 91.1124 50.1991C93.8675 50.6503 96.6904 50.4394 99.3478 49.584C101.817 55.4976 103.089 61.842 103.09 68.2504Z"
            fill="#284154" />
        </svg>
      </div>
      <h1>Nothing to see here</h1>
      <p>Sorry, your search returned 0 results</p>
    </div>
  </div>
}

@if (pager && pager.totalPages > 1) {
  <div class="pager layout-row align-center spacer-vr-16">
    <span class="txt-light-grey">Showing</span>
    <div class="seo-paginator-range-label">{{pager.pageNumber*pager.pageSize+1}} - {{pager.pageNumber*pager.pageSize+pager.numberOfElements}} of
    {{pager.totalElements}}</div>
  </div>
}
@if (pager && pager.totalPages > 1) {
  <div class="pager layout-row align-center spacer-vr-16">
    <!--<mat-paginator class="small" [length]="pager?.totalElements" [pageIndex]="pager.pageNumber" hidePageSize="true" pageSize="10" (page)="gotoPage($event)">
  </mat-paginator>-->
  <div class="seo-paginator small">
    <div class="seo-paginator-range-actions">
      @if (pager.isFirst) {
        <a class="isDisabled pager-icon-button first" href="" aria-disabled="true">
          <span class="pager-button-wrapper">
            <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
            </svg>
            <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
            </svg>
          </span>
        </a>
      } @else {
        <a [href]="'./search-results/terms/'+terms" class="pager-icon-button first">
          <span class="pager-button-wrapper">
            <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
            </svg>
            <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
            </svg>
          </span>
        </a>
      }
      @if (pager.isFirst) {
        <a class="isDisabled pager-icon-button" href="" aria-disabled="true">
          <span class="pager-button-wrapper">
            <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
            </svg>
          </span>
        </a>
      } @else {
        @if (pager.pageNumber != 1) {
          <a [href]="'./search-results/terms/'+terms+'/page/'+(currentPage-1)" class="pager-icon-button">
            <span class="pager-button-wrapper">
              <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
                <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
              </svg>
            </span>
          </a>
        } @else {
          <a [href]="'./search-results/terms/'+terms" class="pager-icon-button">
            <span class="pager-button-wrapper">
              <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
                <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
              </svg>
            </span>
          </a>
        }
      }
      @for (page of pager.indexes; track page; let i = $index; let first = $first) {
        @if (first) {
          <a [href]="'./search-results/terms/'+terms" class="pager-page-number" [class.active]="pager.indexes[i] === currentPage">
            <span class="pager-button-wrapper">
              {{ pager.indexes[i] }}
            </span>
          </a>
        } @else {
          <a [href]="'./search-results/terms/'+terms+'/page/'+(pager.indexes[i])" class="pager-page-number" [class.active]="pager.indexes[i] === currentPage">
            <span class="pager-button-wrapper">
              {{ pager.indexes[i] }}
            </span>
          </a>
        }
      }
      @if (pager.isLast) {
        <a class="isDisabled pager-icon-button" href="" aria-disabled="true">
          <span class="pager-button-wrapper">
            <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
            </svg>
          </span>
        </a>
      } @else {
        <a [href]="'./search-results/terms/'+terms+'/page/'+(currentPage+1)" class="pager-icon-button">
          <span class="pager-button-wrapper">
            <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
            </svg>
          </span>
        </a>
      }
      @if (pager.isLast) {
        <a href="" class="isDisabled pager-icon-button last" aria-disabled="true">
          <span class="pager-button-wrapper">
            <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
            </svg>
            <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
            </svg>
          </span>
        </a>
      } @else {
        <a [href]="'./search-results/terms/'+terms+'/page/'+(pager.totalPages)" class=" pager-icon-button last">
          <span class="pager-button-wrapper">
            <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
            </svg>
            <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
            </svg>
          </span>
        </a>
      }
    </div>
  </div>
</div>
}
